export enum FieldType {
  Default = "default",
  InputVariable = "inputVariable",
}
